// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import { DocumentTemplateAvailableVariablesInput } from '@/gql/graphql';

const documentTemplateKeys = {
  all: ['documentTemplate'] as const,
  documentTemplateVariables: (
    input: DocumentTemplateAvailableVariablesInput
  ) => {
    return [
      ...documentTemplateKeys.all,
      'documentTemplateVariables',
      input,
    ] as const;
  },
  previewDocumentInstance: (templateId: string, projectId: string) => {
    return [
      ...documentTemplateKeys.all,
      templateId,
      'preview',
      projectId,
    ] as const;
  },
};

export default documentTemplateKeys;
